import type { RouterHistory } from "@tanstack/history";
import { shouldForceReload } from "./navigation-strategy";

export function reloadIfNeeded(path: string): boolean {
  const url = new URL(path, window.location.origin);

  if (!shouldForceReload(url.pathname)) {
    return false;
  }

  window.location.assign(path);
  return true;
}

export function createReloadingHistory(baseHistory: RouterHistory): RouterHistory {
  return {
    ...baseHistory,
    get location() {
      return baseHistory.location;
    },
    push(
      path: Parameters<RouterHistory["push"]>[0],
      state: Parameters<RouterHistory["push"]>[1],
      navigateOpts: Parameters<RouterHistory["push"]>[2],
    ) {
      if (reloadIfNeeded(path)) {
        return;
      }

      baseHistory.push(path, state, navigateOpts);
    },
    replace(
      path: Parameters<RouterHistory["replace"]>[0],
      state: Parameters<RouterHistory["replace"]>[1],
      navigateOpts: Parameters<RouterHistory["replace"]>[2],
    ) {
      const url = new URL(path, window.location.origin);

      if (shouldForceReload(url.pathname)) {
        window.location.replace(path);
        return;
      }

      baseHistory.replace(path, state, navigateOpts);
    },
  };
}
